/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, memo } from 'react';

import { useRouter } from 'next/router';

import { AxiosInstance } from '../../utilities';
import TeaserSongListComponent from "../BandComponent/TeaserSongListComponent/TeaserSongListComponent";
import FooterNavComponent from "../FooterComponent/FooterNavComponent/FooterNavComponent";
import GetInTouchComponent from "../FooterComponent/GetInTouchComponent/GetInTouchComponent";
import RecentCitiesComponent from "../FooterComponent/RecentCitiesComponent/RecentCitiesComponent";
import HeaderComponent from "../HeaderComponent/HeaderComponent";
import TrustedByComponent from "../HomeComponent/TrustedByComponent/TrustedByComponent";
import CitiesWePerformComponent from "./CitiesWePerformComponent/CitiesWePerformComponent";
import CityAboutComponent from "./CityAboutComponent/CityAboutComponent";
import CityBandPerformedComponent from "./CityBandPerformedComponent/CityBandPerformedComponent";
import CitySliderComponent from "./CitySliderComponent/CitySliderComponent";
import VenueReviewComponent from "./VenueReviewComponent/VenueReviewComponent";

const setInitialBandPerformedData = (data) => {
  if (Array.isArray(data?.detail) && data.detail.length) {
    return data.detail[0].bandsPerformed;
  }
  return [];
};

const CityDetailsComponent = memo(function CityDetailsComponent(props) {
  // Extract trustedBy data from cmsData if available.
  let trustedByData = null;
  if (Array.isArray(props.cmsData)) {
    const found = props.cmsData.find(item => item.key === "trustedBy");
    if (found) {
      trustedByData = found;
    }
  }

  const [cities, setCities] = useState(props.cityDetails?.list || []);
  const [gallery, setGallery] = useState([]);
  const [bandPerformed, setBandPerformed] = useState(setInitialBandPerformedData(props.cityDetail));
  const [sliderDetail, setSliderDetail] = useState(props.cityDetails?.detail?.[0]?.slider || []);
  const [cityDetail, setCityDetail] = useState(props.cityDetails?.detail?.[0] || {});
  const [footerData, setFooterData] = useState(props.footerData || null);
  const [showAll, setShowAll] = useState(true);
  const router = useRouter();

  // Fetch city details on slug change.
  useEffect(() => {
    window.scroll(0, 0);
    fetchCityDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.slug]);

  // Update footer cms data when showAll changes.
  useEffect(() => {
    const data = { showAll };
    fetchFooterCmsData(data);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAll]);

  const fetchCityDetails = () => {
    AxiosInstance(4008)
      .get(`/city/${props.slug}`)
      .then((resp) => {
        const response = resp && resp.data;
        if (response && (response.status === 200 || response.status === "200")) {
          setCities(response.list);
          if (Array.isArray(response.detail) && response.detail.length) {
            setBandPerformed(response.detail[0].bandsPerformed);
            setSliderDetail(response.detail[0].slider);
            setCityDetail(response.detail[0]);
            setGallery(response.detail[0]?.galleryData || []);
          }
        }
      });
  };

  const fetchFooterCmsData = (data) => {
    AxiosInstance(4008, "application/json")
      .post("/footerLinks", data)
      .then((resp) => {
        const response = resp && resp.data;
        if (response && (response.status === 200 || response.status === "200")) {
          setFooterData(response.data);
        } else if (response && (response.status === 400 || response.status === "400")) {
          setFooterData(null);
        }
      })
      .catch((err) => {
        console.log("Error fetching footer CMS data:", err?.message);
      });
  };

  const showMoreHandler = () => {
    setShowAll(!showAll);
    const data = { showAll: true };
    fetchFooterCmsData(data);
  };

  const showLessHandler = () => {
    setShowAll(!showAll);
    const data = { showAll: false };
    fetchFooterCmsData(data);
  };

  const onNavigateTo = (path) => {
    window.scroll(0, 0);
    router.push(path);
  };

  return (
    <>
      <HeaderComponent />
      <CitySliderComponent sliderDetail={sliderDetail} venueURL={cityDetail.venueURL} />
      {Array.isArray(cityDetail.videos) && cityDetail.videos.length > 0 && (
        <TeaserSongListComponent data={cityDetail.videos} />
      )}
      <CityBandPerformedComponent data={bandPerformed} name={cityDetail.name} venueURL={cityDetail.venueURL} />
      <CityAboutComponent aboutCity={cityDetail.aboutCity} />
      <VenueReviewComponent citySlug={props.slug} />
      <CitiesWePerformComponent onNavigateTo={onNavigateTo} cities={cities} />
      <TrustedByComponent trustedByData={trustedByData} />
      <RecentCitiesComponent
        footerData={footerData && footerData.cities ? footerData.cities : []}
        show_more={footerData && footerData.show_more}
        show_less={footerData && footerData.show_less}
        show_more_handler={showMoreHandler}
        show_less_handler={showLessHandler}
      />
      <GetInTouchComponent />
      <FooterNavComponent footerData={footerData} />
    </>
  );
});

export default CityDetailsComponent;
